/**
 * Mockup v3 P9 (Reportes): the strings of the activity tiles, the cost by model and flow, the
 * latency table and the Flujos tab. Spread into `es` by `es.ts`; P9 adds its keys here only. The
 * scaffold put the two tabs of Modelos here (copy from `mockup-ux-redesign-v3.html`, "Secciones de
 * modelos"), since P9 owns the Flujos tab.
 */
export const esReports = {
  "reports.activity.title": "Actividad del mes",
  "reports.activity.meta": "Enlaces activos contados ahora",
  "reports.activity.tiles.label": "Actividad del mes",
  "reports.activity.mockups": "Mockups creados",
  "reports.activity.versions": "Versiones generadas",
  "reports.activity.links": "Enlaces activos",
  "reports.activity.compare.up": "+{count} frente a {month}",
  "reports.activity.compare.down": "−{count} frente a {month}",
  "reports.activity.compare.same": "Igual que en {month}",
  "reports.activity.average": "{count} por mockup de media",
  "reports.activity.month.january": "enero",
  "reports.activity.month.february": "febrero",
  "reports.activity.month.march": "marzo",
  "reports.activity.month.april": "abril",
  "reports.activity.month.may": "mayo",
  "reports.activity.month.june": "junio",
  "reports.activity.month.july": "julio",
  "reports.activity.month.august": "agosto",
  "reports.activity.month.september": "septiembre",
  "reports.activity.month.october": "octubre",
  "reports.activity.month.november": "noviembre",
  "reports.activity.month.december": "diciembre",
  "reports.activity.linksMeta": "{created} creados y {revoked} revocados este mes",
  "reports.activity.soFar": "{month} hasta hoy",
  "reports.activity.wholeMonth": "{month} completo: {count}",
  "reports.costs.title": "Costo por modelo y flujo",
  "reports.costs.by.label": "Agrupar el costo",
  "reports.costs.by.model": "Por modelo",
  "reports.costs.by.flow": "Por flujo",
  "reports.costs.currency": "En {currency}",
  "reports.costs.column.model": "Modelo",
  "reports.costs.column.calls": "Llamadas",
  "reports.costs.column.cost": "Costo",
  "reports.costs.column.share": "Parte del gasto",
  "reports.costs.column.flow": "Flujo y revisión",
  "reports.costs.column.generations": "Generaciones",
  "reports.costs.column.delivered": "Entregadas",
  "reports.costs.column.failed": "Fallidas",
  "reports.costs.column.cancelled": "Canceladas",
  "reports.costs.share": "{percent} %",
  "reports.costs.empty.title": "Sin costos en el periodo",
  "reports.costs.empty.body": "Cuando alguien de tu organización genere un mockup verás aquí el costo por modelo y por flujo.",
  "reports.consumption.rows.person": "Gasto por persona",
  "reports.consumption.rows.team": "Gasto por equipo",
  "reports.latency.title": "Latencia y errores por modelo y paso",
  "reports.latency.organization": "Organización",
  "reports.latency.meta": "{organization} · del {from} al {to}",
  "reports.latency.period": "Periodo",
  "reports.latency.period.month": "Este mes",
  "reports.latency.period.week": "Últimos 7 días",
  "reports.latency.column.model": "Modelo",
  "reports.latency.column.step": "Paso",
  "reports.latency.column.calls": "Llamadas",
  "reports.latency.column.failures": "Pasos fallidos",
  "reports.latency.column.rate": "Tasa",
  "reports.latency.column.pFifty": "Duración p50",
  "reports.latency.column.pNinetyFive": "Duración p95",
  "reports.latency.column.max": "Máxima",
  "reports.latency.rate": "{rate} %",
  "reports.latency.rateBad": " (por encima del 3 % objetivo)",
  "reports.latency.seconds": "{seconds} s",
  "reports.latency.help":
    "Cuenta los pasos que el modelo respondió y que terminaron con error. Los tiempos de espera y los errores 5xx del proveedor no dejan paso: se ven en el estado del proveedor.",
  "reports.latency.empty.title": "Sin pasos en el periodo",
  "reports.latency.empty.body": "Cuando esta organización genere algo verás aquí la latencia y los errores de cada modelo y paso.",
  "reports.latency.noOrganizations.title": "Sin organizaciones",
  "reports.latency.noOrganizations.body": "Cuando exista una organización podrás ver aquí su latencia y sus errores.",
  "reports.export.csv": "Exportar CSV",
  "reports.export.failed": "No se pudo descargar el archivo. Inténtalo de nuevo.",
  "admin.models.tabs.label": "Secciones de modelos",
  "admin.models.tab.settings": "Configuración",
  "admin.models.tab.flows": "Flujos",
  "admin.flows.notice":
    "Un flujo es la secuencia de pasos con la que se genera algo. Cada cambio crea una revisión nueva; las generaciones en curso terminan con la revisión con la que empezaron. Solo lectura.",
  "admin.flows.table.label": "Flujos de generación",
  "admin.flows.column.flow": "Flujo",
  "admin.flows.column.what": "Qué hace",
  "admin.flows.column.revision": "Revisión actual",
  "admin.flows.column.steps": "Pasos",
  "admin.flows.revision": "r{version}",
  "admin.flows.empty.title": "Sin flujos",
  "admin.flows.empty.body": "No hay flujos de generación registrados.",
  "admin.flows.what.prototype": "Genera cada versión del prototipo",
  "admin.flows.what.update": "Aplica un cambio a la versión actual del prototipo",
  "admin.flows.what.prototypeFromBrief": "Genera el prototipo a partir de un brief",
  "admin.flows.what.assess": "Decide si la petición basta para dibujar o hace preguntas",
  "admin.flows.what.summarize": "Redacta el resumen de diseño de cada versión",
  "admin.flows.what.diagram": "Dibuja el recorrido del usuario",
  "admin.flows.what.diagramWalkthrough": "Dibuja el recorrido pantalla por pantalla",
  "admin.flows.what.brief": "Redacta el brief que la persona revisa antes de dibujar",
  "admin.flows.role.normalize": "Normalizar",
  "admin.flows.role.assess": "Evaluar",
  "admin.flows.role.desktop": "Escritorio",
  "admin.flows.role.mobile": "Móvil",
  "admin.flows.role.summarize": "Resumir",
  "admin.flows.role.diagram": "Diagrama",
  "admin.flows.role.name": "Nombrar",
} as const;
